/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Media_Type_UnknownInputs */

const en_enum_media_type_unknown = /** @type {(inputs: Enum_Media_Type_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

const de_enum_media_type_unknown = /** @type {(inputs: Enum_Media_Type_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unknown`)
};

/**
* | output |
* | --- |
* | "Unknown" |
*
* @param {Enum_Media_Type_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_media_type_unknown = /** @type {((inputs?: Enum_Media_Type_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Media_Type_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_media_type_unknown(inputs)
	return de_enum_media_type_unknown(inputs)
});